import { useSelector } from "react-redux";
import { Language } from "../api/types/config";
import { RootState } from "../store";

/**
 * Get current languages selection
 * @returns 
 */
export const useAvailableLanguages = ():Array<Language> => {
  return useSelector((state: RootState) => state.config.languages);
}